module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAAQ5JREFUKFOlk9FxwkAMRFcd0AGUQAdQAnRAOnAJoQOoIOkAOkg6gBLSQdLBZt6NzmPOdvKBZvRx59uVdiWHnohosbYXkj4k/Ug6RsTnHP8U+FXSStJ7JkSQfLUkD2DbgKi0jggqy3YnidxFxH1I0IKvkq4RQdU+bAPqWgk92PZW0iki1g1wl0C+P8QQPMluG61Upasx2PYhNVFl2C7mcYcXb2lc8YIolW1zgSH9WNK8G1IkndM0ikByxtAK5kHVVtqzjWm0jAdLSS95xvlCMtTMI0ic82W2tAsRZkF2oXVJnLupJYGVxKR+rrl5debfkvYj8H+rnl5s2YWqGVc3M8B93ba5UaGt6Bs9+OPH+AXcdnl2nTFO7wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_t2_on.png
// module id = Qx/V
// module chunks = 85